export default __webpack_public_path__ + "static/media/placeholder-template.0f3bd0e8.svg";